
import { Card } from "@/components/ui/card";
import { Match } from "@/components/MatchCard";

interface MatchesStatsProps {
	matches: Match[];
	isLoading: boolean;
}

export const MatchesStats = ({ matches, isLoading }: MatchesStatsProps) => {
	if (isLoading) {
		return (
			<div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
				{[1, 2, 3].map((i) => (
					<Card key={i} className="p-4 animate-pulse">
						<div className="h-5 bg-gray-200 rounded w-1/3 mb-2"></div>
						<div className="h-7 bg-gray-200 rounded w-1/2"></div>
					</Card>
				))}
			</div>
		);
	}

	const totalMatches = matches.length;
	const averageScore = matches.length > 0 
		? Math.round(matches.reduce((acc, match) => acc + match.score, 0) / matches.length)
		: 0;
	
	// Calculate average matches per job
	const jobsWithMatches = new Set(matches.map(match => match.jobId)).size;
	const avgMatchesPerJob = jobsWithMatches > 0 
		? Math.round((totalMatches / jobsWithMatches) * 10) / 10
		: 0;

	return (
		<div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
			<Card className="p-4">
				<h3 className="text-sm font-medium text-gray-500 mb-1">Total Matches</h3>
				<p className="text-2xl font-bold text-gray-900">{totalMatches}</p>
			</Card>
			
			<Card className="p-4">
				<h3 className="text-sm font-medium text-gray-500 mb-1">Avg. Matches per Job</h3>
				<p className="text-2xl font-bold text-gray-900">{avgMatchesPerJob}</p>
			</Card>
			
			<Card className="p-4">
				<h3 className="text-sm font-medium text-gray-500 mb-1">Avg. Match Score</h3>
				<p className="text-2xl font-bold text-gray-900">{averageScore}%</p>
			</Card>
		</div>
	);
};
